import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './i18n';
import './index.scss';
import { reportWebVitalsEnhanced } from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Enhanced Web Vitals reporting with Google Analytics integration
// This will automatically send Core Web Vitals metrics to Google Analytics
// and provide console logging in development mode
reportWebVitalsEnhanced();

// Alternative: Basic Web Vitals reporting to Google Analytics only
// reportWebVitals(sendToGoogleAnalytics);
